import { render, staticRenderFns } from "./DynamicDetailView.vue?vue&type=template&id=25c3e74a&scoped=true"
import script from "./DynamicDetailView.vue?vue&type=script&lang=js"
export * from "./DynamicDetailView.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetailView.vue?vue&type=style&index=0&id=25c3e74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3e74a",
  null
  
)

export default component.exports